define('Header.Common', [
    'SC.Configuration',
    'Utils'
], function HeaderCommon(
    Configuration,
    Utils
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var LayoutComponent = container.getComponent('Layout');
            var useMobileLogo = Configuration.get('header.useMobileLogo');
            LayoutComponent.addToViewContextDefinition('Header.Logo.View', 'logoUrl', 'string', function addLogoUrl() {
                if (useMobileLogo && !Utils.isDesktopDevice()) {
                    return Configuration.get('header.mobileLogoUrl');
                }
                return Configuration.get('header.logoUrl');
            });
        }
    };
});
